import React from "react";
import { Privilege } from "@/api/privileges";
import {
  MultipleSelectDataGrid,
  DataGridColumn,
} from "@/ui-controls/DataGrid";

interface Props {
  appPrivileges: Privilege[];
  onSelectionChanged: (selectedList: Privilege[]) => any;
}

const PrivilegeSelectDetailList = (props: Props) => {
  const columns: DataGridColumn[] = [
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
  ];

  return (
    <>
      <MultipleSelectDataGrid
        items={props.appPrivileges}
        columns={columns}
        onSelectionChanged={props.onSelectionChanged}
      />
    </>
  );
};

export default PrivilegeSelectDetailList;
